import type { SearchHashtags200HashtagsItem } from './searchHashtags200HashtagsItem';

export type SearchHashtags200 = {
  hashtags?: SearchHashtags200HashtagsItem[];
  query?: string;
};
